import { Component } from '@angular/core';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.page.html',
  styleUrl: '../legal.page.scss'
})
export class CookiesPage {

}
